export const hrefsafe = {
  name: 'hrefsafe',
  inserted: function (el, binding) {
    const userProvidedUrl = binding.value;
    if (isValidURL(userProvidedUrl)) {
      el.setAttribute('href', userProvidedUrl);
    } else {
      console.error('Invalid URL:', userProvidedUrl);
    }
  },
};
 
// Function to validate URL
function isValidURL(url) {
  const MAX_INPUT_LENGTH = 1000; // Set a reasonable maximum input length
  // Pre-match validation
  if (url.length > MAX_INPUT_LENGTH) {
      return false; // Reject excessively long inputs
  }
  //check if url containes https or http
  if (
    !(url.indexOf('http://') == 0 || url.indexOf('https://') == 0) &&
    !url.indexOf('www') == 0
  ) {
    let currentorigin = location.origin;
    url = currentorigin + url;
  }
  // Optimized regular expression for URL validation
  const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
  return urlRegex.test(url);
}